import React, { useState } from "react";
import Sidebar from "../../components/Dashboard/Sidebar/Sidebar";
import Header from "../../components/Dashboard/Header/Header";
import SummaryCard from "../../components/Dashboard/SummaryCard/SummaryCard";
import RevenueExpenseChart from "../../components/Dashboard/Charts/RevenueExpenseChart";
import POStatusBreakdown from "../../components/Dashboard/Charts/POStatusBreakdown";
import ProjectAgeingReport from "../../components/Dashboard/Widgets/ProjectAgeingReport";
import TaskWorkload from "../../components/Dashboard/Widgets/TaskWorkload";
import TopPerformer from "../../components/Dashboard/Widgets/TopPerformer";
import { Rocket, Clock, FileText, IndianRupee, AlertCircle } from 'lucide-react';
import Breadcrumbs from '../../components/Common/Breadcrumbs/Breadcrumbs';
import styles from './Dashboard.module.css';

const Dashboard = () => {
    const [isSidebarOpen, setIsSidebarOpen] = useState(false);
    const user = JSON.parse(localStorage.getItem('user') || '{}');

    const toggleSidebar = () => setIsSidebarOpen(!isSidebarOpen);

    const summaryData = [
        {
            icon: <Rocket size={20} />,
            label: 'Active Projects',
            value: '42',
            trend: '+12%',
            trendType: 'up',
            iconBg: '#ff9d42'
        },
        {
            icon: <Clock size={20} />,
            label: 'Delayed Projects',
            value: '8',
            trend: '-2%',
            trendType: 'down',
            iconBg: '#f59e0b'
        },
        {
            icon: <FileText size={20} />,
            label: 'Pending POs',
            value: '24',
            trend: '+5%',
            trendType: 'up',
            iconBg: '#3b82f6'
        },
        {
            icon: <IndianRupee size={20} />,
            label: 'Revenue (YTD)',
            value: '₹1.2M',
            trend: '+8.4%',
            trendType: 'up',
            iconBg: '#10b981'
        },
        {
            icon: <AlertCircle size={20} />,
            label: 'Overdue Tasks',
            value: '15',
            trend: '+15%',
            trendType: 'down',
            iconBg: '#ef4444'
        }
    ];

    return (
        <div className={`${styles['dashboard-container']} ${isSidebarOpen ? styles['sidebar-open'] : ''}`}>
            {isSidebarOpen && <div className={styles['sidebar-overlay-dashboard']} onClick={() => setIsSidebarOpen(false)}></div>}
            <Sidebar isOpen={isSidebarOpen} onClose={() => setIsSidebarOpen(false)} />

            <div className={styles['content-wrapper']}>
                <Header onMenuClick={toggleSidebar} />
                <main className={styles['main-content']}>
                    <Breadcrumbs />
                    <div className={styles['dashboard-header-area']}>
                        <div className={styles['welcome-section']}>
                            <h1>Welcome back, {user?.name || 'User'}</h1>
                            <p>Here's what's happening with your projects today, {new Date().toLocaleDateString('en-US', { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' })}.</p>
                        </div>
                    </div>

                    {/* <div className={styles['summary-section']}>
                        {summaryData.map((data, index) => (
                            <SummaryCard key={index} {...data} />
                        ))}
                    </div>

                    <div className={styles['charts-section']}>
                        <div className={`${styles['revenue-expense-col']} ${styles['dashboard-card']}`}>
                            <RevenueExpenseChart />
                        </div>
                        <div className={`${styles['po-status-col']} ${styles['dashboard-card']}`}>
                            <POStatusBreakdown />
                        </div>
                    </div>

                    <div className={styles['bottom-section']}>
                        <div className={`${styles['ageing-report-col']} ${styles['dashboard-card']}`}>
                            <ProjectAgeingReport />
                        </div>
                        <div className={styles['sidebar-widgets-col']}>
                            <div className={styles['dashboard-card']}>
                                <TaskWorkload />
                            </div>
                            <div className={`${styles['dashboard-card']} ${styles['card-orange']}`}>
                                <TopPerformer />
                            </div>
                        </div>
                    </div> */}
                </main>
            </div>
        </div>
    );
};

export default Dashboard;